import {useParams } from "react-router-dom";
import "../assets/css/pages/craft-beer.scss";
import { Dictionary } from "../assets/js/contexts";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import React, { useEffect, useState } from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import { useLang } from "../helpers/language";
import parse from "html-react-parser";
import { Virtual } from "swiper";

SwiperCore.use([Navigation]);
SwiperCore.use([Pagination]);

const Cider = ({ dictionary }) => {
  const [swiper, setSwiper] = useState(null);
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);
  const [data, setdata] = useState([]);
  let id = useParams().id;
  const [activeIndex, setactiveIndex] = useState(0);

  const slideTo = (index) => swiper?.slideTo(index);
  useEffect(() =>
  {
    window.scrollTo(0, 0);
    (async () => {
      let rowdata = await API.get(config.api.cider, {}, {}, true);
      setdata(rowdata);

      if (id !== "") {
        rowdata.forEach((element, index) => {
          if (element._id === id) {
            setactiveIndex(index);
          }
        });
      }

      setBusy(false);
    })();
    // eslint-disable-next-line
  }, [isBusy]);

  useEffect(() => {
    slideTo(activeIndex);
    // eslint-disable-next-line
  }, [swiper]);

  if (!isBusy && data.length > 0)
    return (
        <Dictionary.Provider value={dictionary}>
          <div id="craft-beer">
            <div className="slider-container">
              <div className="container">
                <button className={"swiper-button-prev  d-none d-md-block"} aria-label="prev">
                  <img src="/static/icons/arrow-white.svg" data-arrow="left" alt=""/>
                </button>
                <button className={"swiper-button-next  d-none d-md-block"} aria-label="next">
                  <img src="/static/icons/arrow-white.svg" data-arrow="right" alt="" />
                </button>
              </div>
                  <Swiper
                      spaceBetween={0}
                      modules={[Virtual, Navigation, Pagination]}
                      slidesPerView={1}
                      onSwiper={setSwiper}
                      onSlideChange={(event) => {
                        window.history.replaceState(
                            null,
                            "",
                            `/${config.api.cider}/${
                                data[event.activeIndex]._id
                            }?lang=${lang}`
                        );
                      }}
                      navigation={{
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                      }}
                      pagination={{
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                      }}
                  >
                    {data?.map((bottle, index) => (
                        <SwiperSlide key={index} virtualIndex={index}>
                          <div key={index}>
                            <div className="container">
                              <div className="row">
                                <div className="col-lg-9 left">
                                  <h1>
                                    {bottle?.name
                                        ? bottle?.name
                                            ? bottle?.name[lang]
                                                ? bottle?.name[lang]
                                                : ""
                                            : ""
                                        : ""}
                                  </h1>
                                  {parse(
                                      bottle?.desc
                                          ? bottle?.desc
                                              ? bottle?.desc[lang]
                                                  ? bottle?.desc[lang]
                                                  : ""
                                              : ""
                                          : ""
                                  )}
                                  <p style={{ marginTop: 47, marginBottom: 44 }}>
                                    {`ALC ${bottle?.alc ? bottle?.alc : ""}% / IBU ${
                                        bottle?.ibu ? bottle?.ibu : ""
                                    }`}
                                  </p>
                                  <p className="m-0">
                                    <b>Matchable With Text</b>
                                  </p>
                                  <div className="d-flex flex-wrap">
                                    {Object.entries(bottle?.icons)?.map(
                                        (obj, index) => {
                                          if (obj[1]) {
                                            return (
                                                <img
                                                    key={index}
                                                    src={`/static/icons/foods/${obj[0]}.svg`}
                                                    alt=""
                                                />
                                            );
                                          } else return null
                                        }
                                    )}
                                  </div>
                                  {/* <button
                            className="round black"
                            style={{ marginTop: 42 }}
                          >
                            Explore
                          </button> */}
                                </div>
                                <div
                                    className="col-lg-3 right"
                                    style={{
                                      backgroundImage: `url(/static/images/beer-words/${
                                          bottle?.name?.en
                                              ? bottle?.name?.en.split(" ")[0]
                                              : "belgian"
                                      }.svg)`,
                                    }}
                                >

                                  <img
                                      src={bottle.uploads ?`${config.api.API_URL}/${bottle?.uploads[0]?.path}` : null}
                                      width="100%"
                                      alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-pagination"></div>
                  </Swiper>
            </div>
          </div>
        </Dictionary.Provider>
    );
  return <Loading type="Oval" color="#FFBE03" className="dms-loader" />;
};

export default Cider;
